import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, RouterOutlet } from '@angular/router';
import { NavbarComponent } from './navbar/navbar.component';
import { TypographyModule } from '@progress/kendo-angular-typography';
import { LOCALE_ID } from '@angular/core';
import { IntlModule, IntlService } from '@progress/kendo-angular-intl';
//import '@progress/kendo-angular-intl/locales/de/all';
import { L10N_PREFIX, LocalizationService, MessageService } from '@progress/kendo-angular-l10n';
import { FooterComponent } from './footer.component';
import { ScrollToTopComponent } from './shared/ui/scroll-to-top.component';
import { GrunddatenService } from './grundlagen/grunddaten.service';
import { UiSpinnerComponent } from './shared/ui/ui-spinner';
import { UiDialogHostComponent } from './shared/ui/dialog/ui-dialog-host.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  imports: [CommonModule, RouterOutlet, RouterModule, NavbarComponent, TypographyModule, IntlModule, FooterComponent, ScrollToTopComponent, UiSpinnerComponent, UiDialogHostComponent],
  providers: [MessageService, LocalizationService, { provide: L10N_PREFIX, useValue: 'de' }],
})
export class AppComponent {
  public intl = inject(IntlService);
  public messages = inject(MessageService);
  public grundDaten = inject(GrunddatenService);

  constructor() {
    this.messages.notify();
  }
}
